/** Keep commas inside CDN transformations and signed query strings intact. */
export const parseMediaUrls = (value: string): string[] =>
  Array.from(new Set(value.split(/\r?\n|,\s*(?=https?:\/\/)/i)
    .map((url) => url.trim()).filter(Boolean)));

export const normalizeMediaUrl = (value: unknown): string | null => {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === "https:" || url.protocol === "http:" ? url.href : null;
  } catch { return null; }
};
